import { Button, Card, ConfigProvider, Modal } from 'antd';
import React, { useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { FlightColumns } from '../Columns';
import '../../types/ColumnDnd.css'; // Import the CSS file

interface ColumnDndProps {
  columns?: any[]; // replace any with the actual type of your columns
  changeColomnsHandler?: (columns: any[]) => void;
}
const ColumnDnd: React.FC<ColumnDndProps> = ({
  columns,
  changeColomnsHandler,
}) => {
  const [items, setItems] = useState(columns || FlightColumns);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    if (changeColomnsHandler) {
      changeColomnsHandler(items);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const handleOnDragEnd = (result: any) => {
    if (!result.destination) return;

    const itemsArray = Array.from(items);
    const [reorderedItem] = itemsArray.splice(result.source.index, 1);
    itemsArray.splice(result.destination.index, 0, reorderedItem);

    setItems(itemsArray);

    // Log the updated items array
    console.log(itemsArray);
  };

  return (
    <>
      <Button type="primary" onClick={showModal}>
        Sort Columns
      </Button>
      <ConfigProvider modal={{}}>
        <Modal
          title="Customized columns position"
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          bodyStyle={{ maxHeight: '60vh', overflow: 'auto' }}
        >
          <div>
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId="select">
                {(provided) => (
                  <ul {...provided.droppableProps} ref={provided.innerRef}>
                    {items.map((item, index) => (
                      <Draggable
                        key={item.key}
                        draggableId={item.key as string}
                        index={index}
                      >
                        {(provided) => (
                          <Card
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className="card1"
                          >
                            <h6>{item.title}</h6>
                          </Card>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </Modal>
      </ConfigProvider>
    </>
  );
};

export default ColumnDnd;
